import { Component, Input } from '@angular/core';

import { SeModalWindowComponent, ButtonClick } from '../se-modalwindow/se-modalwindow.component';
import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
    selector: 'se-modaldialog',
    templateUrl: './se-modaldialog.component.html',
    styleUrls: ['./se-modaldialog.component.scss']
})
export class SeModalDialogComponent extends SeModalWindowComponent {
    @Input()
    header: string;

    @Input()
    description: string;

    _isWarning = false;
    @Input()
    set isWarning(value: BooleanInput) { this._isWarning = coerceBooleanProperty(value) }
    get isWarning() { return this._isWarning; }

    _isError = false;
    @Input()
    set isError(value: BooleanInput) { this._isError = coerceBooleanProperty(value) }
    get isError() { return this._isError; }

    _buttonOk = true;
    @Input()
    set buttonOk(value: BooleanInput) { this._buttonOk = coerceBooleanProperty(value) }
    get buttonOk() { return this._buttonOk; }

    _buttonCancel = false;
    @Input()
    set buttonCancel(value: BooleanInput) { this._buttonCancel = coerceBooleanProperty(value) }
    get buttonCancel() { return this._buttonCancel; }

    _buttonYes = false;
    @Input()
    set buttonYes(value: BooleanInput) { this._buttonYes = coerceBooleanProperty(value) }
    get buttonYes() { return this._buttonYes; }

    _buttonNo = false;
    @Input()
    set buttonNo(value: BooleanInput) { this._buttonNo = coerceBooleanProperty(value) }
    get buttonNo() { return this._buttonNo; }

    _buttonClose = false;
    @Input()
    set buttonClose(value: BooleanInput) { this._buttonClose = coerceBooleanProperty(value) }
    get buttonClose() { return this._buttonClose; }

    _noPaddingInContent = false;
    @Input()
    set noPaddingInContent(value: BooleanInput) { this._noPaddingInContent = coerceBooleanProperty(value) }
    get noPaddingInContent() { return this._noPaddingInContent; }

    @Input()
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onIsButtonOkDisabled: Function = () => {
        return false;
    };

    onOk() {
        this.onBtnClick(ButtonClick.ok);
    }

    onCancel() {
        this.onBtnClick(ButtonClick.cancel);
    }

    onYes() {
        this.onBtnClick(ButtonClick.yes);
    }

    onNo() {
        this.onBtnClick(ButtonClick.no);
    }

    onClose() {
        this.onBtnClick(ButtonClick.close);
    }

    onVisibileChange(visible: boolean) {
        this.visible = visible;
    }
}
